import { apiClient } from './client'

const PREFIX = '/api/internal/customer'

export const favoritesApi = {
  getFavorites: () =>
    apiClient
      .get<{ product_ids: number[] }>(`${PREFIX}/favorites/`)
      .then((r) => r.data.product_ids),

  add: (product_id: number) =>
    apiClient.post(`${PREFIX}/favorites/`, { product_id }),

  remove: (product_id: number) =>
    apiClient.delete(`${PREFIX}/favorites/${product_id}/`),
}
